
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Growl } from "primereact/growl";
import { InputText } from "primereact/inputtext";
import React, { Component } from "react";
import { trackPromise } from "react-promise-tracker";
import { HttpService } from "../service/HttpService";
import { checkForError } from "../utility/AppUtility";
import { AppBreadcrumb } from "../AppBreadcrumb";
import moment from "moment";
import _ from "lodash";

export class ConsignmentList extends Component {
  constructor() {
    super();
    this.state = {
      dataTableValue: [],
      page: 1,
      totalRecords: 0,
      size: 10,
      expandedRows: null,
      first: 0,
      globalFilter: "",
      filters: {
        reference: "",
        noOfBox: "",
        overallStatus: "",
         sending_date: "",
      },
    };

    this.httpService = new HttpService();
    this.rowExpansionTemplate = this.rowExpansionTemplate.bind(this);

    // Debounced API call for server-side filtering
    this.handleFilterChange = _.debounce(() => {
      this.getList(this.state.page - 1);
    }, 300);
  }

  componentDidMount() {
    this.getList(this.state.page - 1);
  }

  getList = (page) => {
    const { filters, size } = this.state;

    let params = `page=${page}&size=${size}&sort=createdDate,desc`;
    if (filters.reference) params += `&reference=${filters.reference}`;
    if (filters.noOfBox) params += `&noOfBox=${filters.noOfBox}`;
    if (filters.overallStatus) params += `&overallStatus=${filters.overallStatus}`;
    if (filters.sending_date) params += `&sending_date=${filters.sending_date}`;

    trackPromise(
      this.httpService
        .getApi(`v1/consignment/web/get_all?${params}`)
        .then((response) => {
          this.setState({
            dataTableValue: response.data.content,
            totalRecords: response.data.totalElements,
          });
        })
        .catch((error) => {
          if (checkForError(error))
            this.growl.show({
              severity: "error",
              summary: "Error Message",
              detail: error.response.data.title,
            });
        })
    );
  };

  showMessage(severity, summary, message) {
    let msg = { severity: severity, summary: summary, detail: message };
    this.growl.show(msg);
  }

  onPageChange = (event) => {
    this.setState(
      {
        page: event.page,
        first: event.first,
      },
      () => this.getList(event.page)
    );
  };

  rowExpansionTemplate(data) {
    return (
      <div className="orders-subtable">
        <h4>List of Product </h4>
        <DataTable value={data.palletLabels.reverse()}>
          <Column field="name" header="Product Name" sortable></Column>
          <Column field="description" header="Product Description" sortable></Column>
          <Column field="count" header="Product Quantity" sortable></Column>
        </DataTable>
      </div>
    );
  }

  returnHeader = () => {
    return (
      <div>
        <div>Consignments</div>
        <div className="p-datatable-globalfilter-container">
          <InputText
            type="search"
            value={this.state.globalFilter}
            onChange={(e) => this.setState({ globalFilter: e.target.value })}
            placeholder="Global Search"
          />
        </div>
      </div>
    );
  };

  returnValue = (rowData) => {
    return moment(new Date(rowData.sendingDate))
      .format("DD-MM-YY hh:mm a")
      .toString();
  };

  expandAll() {
    let expandedRows = {};
    this.state.dataTableValue.forEach((p) => (expandedRows[`${p.id}`] = true));
    this.setState({ expandedRows });
  }

  collapseAll() {
    this.setState({ expandedRows: null });
  }

  handleColumnFilterChange = (field, value) => {
    this.setState(
      { filters: { ...this.state.filters, [field]: value } },
      () => this.handleFilterChange()
    );
  };

  render() {
    let actionHeader = <Button type="button" icon="pi-md-settings" />;

    return (
      <>
        <AppBreadcrumb breadcrumdItems={[{ label: "Consignment List" }]} />
        <div className="p-grid">
          <div className="p-col-12">
            <Growl
              ref={(el) => (this.growl = el)}
              style={{ marginTop: "75px" }}
            />

            <div className="datatable-demo">
              <div className="p-col-12">
                <font className="font21Weight500">Consignment</font>
              </div>



              <DataTable
  ref={(el) => (this.dt = el)}
  value={this.state.dataTableValue}
  rowExpansionTemplate={this.rowExpansionTemplate}
  paginator
  dataKey="id"
  expandedRows={this.state.expandedRows}
  rows={10}
  header="List of Consignments"
  onRowToggle={(e) => this.setState({ expandedRows: e.data })}
  responsive
  resizableColumns
  columnResizeMode="fit"
  lazy
  first={this.state.first}
  totalRecords={this.state.totalRecords}
  onPage={(event) => this.onPageChange(event)}
>
  <Column expander style={{ width: "3em" }} />

  <Column
    field="reference"
    header={
      <div style={{ display: "flex", flexDirection: "column" }}>
        <span>Ref. No.</span>
        <InputText
          value={this.state.filters.reference}
          onChange={(e) =>
            this.handleColumnFilterChange("reference", e.target.value)
          }
          placeholder="Reference"
          style={{ marginTop: "4px" }}
        />
      </div>
    }
    sortable
  />

  <Column
    field="noOfBox"
    header={
      <div style={{ display: "flex", flexDirection: "column" }}>
        <span>Items</span>
        <InputText
          value={this.state.filters.noOfBox}
          onChange={(e) =>
            this.handleColumnFilterChange("noOfBox", e.target.value)
          }
          placeholder="No of Box"
          style={{ marginTop: "4px" }}
        />
      </div>
    }
    sortable
  />

  <Column
    field="overallStatus"
    header={
      <div style={{ display: "flex", flexDirection: "column" }}>
        <span>Status</span>
        <InputText
          value={this.state.filters.overallStatus}
          onChange={(e) =>
            this.handleColumnFilterChange("overallStatus", e.target.value)
          }
          placeholder="Status"
          style={{ marginTop: "4px" }}
        />
      </div>
    }
    sortable
  />

  <Column
    field="sendingDate"
    header={
      <div style={{ display: "flex", flexDirection: "column" }}>
        <span>Created Date</span>
        <InputText
          value={this.state.filters.sending_date}
          onChange={(e) =>
            this.handleColumnFilterChange("sending_date", e.target.value)
          }
          placeholder="Sending Date"
          style={{ marginTop: "4px" }}
        />
      </div>
    }
    sortable
  />
</DataTable>






            </div>
          </div>
        </div>
      </>
    );
  }
}
